import Vue from 'vue'
import App from './App'
import router from './router/index'
import axios from "axios"
import $ from 'jquery'
import './base/css/common.css'
import rem from './base/js/rem.js'
import utils from '@/base/js/utils'
import WxTool from './base/js/wxtool-qmmc.js'
import html2canvas from 'html2canvas'
import qrcode from 'qrcode'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'

Vue.use(DatetimePlugin)
Vue.use(ConfirmPlugin)
Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.use(AlertPlugin)
Vue.prototype.utils = utils;


var _wxTool=new WxTool("2016AELyytfACE");




Vue.prototype._wxTool = _wxTool;
Vue.prototype.html2canvas = html2canvas
Vue.prototype.qrcode = qrcode




/***********/













function  getContextPath() {

var pathname=window.location.pathname;
console.log('pathname1' +pathname)
pathname=pathname.substring(1);
console.log('pathname2' +pathname)
pathname= pathname.substring(0,pathname.indexOf('/'))
console.log('pathname3' +pathname)

return pathname;

}

Vue.prototype.$url =window.location.protocol+"//"+window.location.host+ '/'+getContextPath();

/***********/


new Vue({
el: '#app',
router,
template: '<App/>',
components: {
App
},
data:{
app_user:{
eip:'2',//用户id
cn:'test',
mobile:'18539918065',
email:'test@qq.com'
}
}
})
Date.prototype.format = function(fmt) {
var o = {
"M+": this.getMonth() + 1, //月份
"d+": this.getDate(), //日
"h+": this.getHours(), //小时
"m+": this.getMinutes(), //分
"s+": this.getSeconds(), //秒
"q+": Math.floor((this.getMonth() + 3) / 3), //季度
"S": this.getMilliseconds() //毫秒
};
if(/(y+)/.test(fmt)) {
fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
}
for(var k in o) {
if(new RegExp("(" + k + ")").test(fmt)) {
fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
}
}
return fmt;
}

Vue.prototype.$TelText = function(v){
var mobile = /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/


if(mobile.test(v)){
return true;
}else{
return false;
}
}

Vue.prototype.$passWord = function(str){
let regExp =/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/;
if(regExp.test(str)){
return true;
}else{
return false;
}
}

router.afterEach((to, from, next) => {
setTimeout(()=>{
var _hmt = _hmt || [];
(function() {

document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
var hm = document.createElement("script");
hm.src = "https://hm.baidu.com/hm.js?1c7e19555c747737c9064d29ea238f27";
hm.id = "baidu_tj"
if (to.path) {
_hmt.push(['_trackPageview', '/#' + to.fullPath]);
}


var s = document.getElementsByTagName("script")[0];
s.parentNode.insertBefore(hm, s);
})();
},0);
})











// WEBPACK FOOTER //
// ./src/main.js